<template>
  <div class="historyComponent">
    <van-list
        v-model="loading"
        :offset="300"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
    >
      <van-cell v-for="(item,index) in NewhistoryList" :key="index" class="content">
        <p class="monthHistory-title">{{ item.groupName }}</p>
        <div
            v-for="(historyItem,index) in item.data"
            :key="index"
            class="monthHistory-detail"
            @click="goHistoryDetail(historyItem.id)"
        >
          <div class="monthHistory-detail-left">
            <p>
              <span class="left-name hasMar">{{ historyItem.mealRuleName | filterName }}</span>
            </p>
            <p>
              <span class="hasMar">{{ historyItem.receiptor }} {{ historyItem.createDate }}</span>
            </p>
          </div>
          <div class="monthHistory-detail-right">
            <span :class="historyItem.bookingStatus">{{ historyItem.bookingStatus | formatStatus }}</span>
          </div>
        </div>
      </van-cell>
    </van-list>
  </div>
</template>

<script>
import { eatList } from '@/api/user';

export default {
  name: 'HistoryComponent',
  filters: {
    // 过滤访客状态
    formatStatus(val) {
      const statusMap = {
        CANCEL: '已取消',
        BOOKING: '预定中',
        START_BOOKING: '发起预定',
        BOOKED: '预定成功',
        LOCK_BOOKING: '已确认'
      };
      return statusMap[val];
    },
    filterName(val) {
      if (val.length > 12) {
        let str = '';
        str = val.substring(0, 12) + '...';
        return str;
      } else {
        return val;
      }
    }
  },
  props: {
    size: {
      type: Number,
      default() {
        return 10;
      }
    },
    activeName: {
      type: String,
      default() {
        return '';
      }
    },
    visiDate: {
      type: String,
      default() {
        return '';
      }
    }
  },
  data() {
    return {
      page: 1,
      total: null,
      loading: false,
      personalInfo: {},
      todayTime: '',
      historyList: [],
      NewhistoryList: [], // 处理统一字段后的historyList
      messageId: '' // 从消息模板进来打开二维码的id
    };
  },
  computed: {
    maxPage() {
      return Math.ceil(this.total / this.size);
    },
    finished() {
      return this.page > this.maxPage;
    }
  },
  watch: {
    activeName: {
      handler(nv) {
        this.getList(nv);
      },
      immediate: true
    },
    historyList: {
      handler(nv) {
        var groupList = [];
        var list = nv.map(val => {
          const createTime = val.bookingDate || '';
          const groupName = `${createTime.split(' ')[0].split('-')[0]}年${createTime.split(' ')[0].split('-')[1]}月`;
          groupList.push(groupName);
          return {
            ...val,
            groupName,
            createTime: val.createTime.slice(-14, -3),
            createDate: `${createTime.split(' ')[0].split('-')[1]}月${createTime.split(' ')[0].split('-')[2]}日`
          };
        });
        groupList = [...new Set(groupList)].map(v => {
          var data = [];
          list.forEach(val => {
            if (v === val.groupName) {
              data.push(val);
            }
          });
          return {
            groupName: v,
            data
          };
        });
        this.NewhistoryList = groupList;
        this.loading = false;
      },
      // immediate: true
      deep: true
    }
  },
  activated() {
    if (this.page !== 1 || this.historyList.length) {
      this.page = 1;
      this.historyList = [];
      this.getList(this.activeName);
    }
  },
  created() {
    this.personalInfo = JSON.parse(localStorage.getItem('personalInfo') || '{}');
  },
  methods: {
    // 申请记录
    getList() {
      const data = {
        page: this.page,
        size: this.size
      };
      eatList(data).then(res => {
        this.historyList.push(...res.data.list);
        this.total = res.data.totals;
      });
    },
    onLoad() {
      if (this.page > this.maxPage) {
        return;
      } else {
        ++this.page;
      }
      this.getList(this.activeName);
    },
    goHistoryDetail(id) {
      this.personalInfo = JSON.parse(localStorage.getItem('personalInfo') || '{}');
      // this.$router.push({ name: 'staffMeetingHistoryDetail', query: { id: id }});
      this.$router.push({ name: 'mealBookInfo', query: { id: id, from: 'review' }});
    }
  }
};
</script>

<style lang="less" scoped>
.historyComponent {
  /deep/.van-cell {
    padding: 0rem !important;
  }
  .van-cell__value {
    width: 100%;
  }
  .content {
    //  padding: 0rem 0.15rem;
    .monthHistory-title {
      height: 0.45rem;
      line-height: 0.45rem;
      padding: 0rem 0.15rem;
      background: rgba(239, 239, 244, 1);
    }
    .monthHistory-detail {
      display: flex;
      justify-content: space-between;
      //align-items: center;
      font-size: 0.14rem;
      color: rgba(51, 51, 51, 0.7);
      background: #fff;
      //margin-bottom: 0.2rem;
      .monthHistory-detail-left {
        padding: 0.16rem 0.15rem;
        .theme {
          font-size: 0.17rem;
          font-weight: 400;
          line-height: 0.18rem;
          color: #001833;
        }
        p {
          height: 0.24rem;
          line-height: 0.24rem;
          .left-name {
            font-size: 0.17rem;
            color: #001833;
          }
          .hasMar {
            margin-right: 0.16rem;
          }
        }
        p:first-child {
          margin-bottom: 0.02rem;
        }
      }
      .monthHistory-detail-right {
        display: flex;
        align-items: center;
        line-height: 100%;
        margin-right: 0.18rem;

        .right-icon {
          margin-right: 0.18rem;
          .svg-icon {
            width: 0.28rem;
            height: 0.28rem;
          }
          > img {
            width: 0.28rem;
            height: 0.28rem;
          }
        }

        .AUDIT_CANCEL,
        .UNVISIT,
        .AUDIT_FAIL,
        .CANCEL,
        .AUDIT_OUTTIME {
          color: rgba(51, 51, 51, 0.5);
        }
        .AUDIT_WAITTING,
        .WAITING_VERIFY {
          color: #f2b230;
        }
        .OUTTIME_VISIT,
        .AUDIT_REJECT {
          color: #f76260;
        }
        .VISITING,
        .BOOKING,
        .START_BOOKING,
        .WAITING_VISIT {
          color: #3b86ff;
        }
        .FINISH,
        .BOOKED,
        .LOCK_BOOKING,
        .AUDIT_PASS {
          color: #2dcc2c;
        }
      }
    }
    .monthHistory-detail:not(:last-child) {
      border-bottom: 1px solid rgba(229, 229, 229, 1);
    }
  }
}
</style>
